// Crypto-specific review dimensions (SPEC §3.4). Shared by API validation and the
// frontend radar/breakdown. dimension_key is stored in review_dimensions.

export interface Dimension {
  key: string;
  label: string;
  hint: string;
}

export const TOKEN_DIMENSIONS: Dimension[] = [
  { key: "tokenomics", label: "Tokenomics & transparency", hint: "Supply, distribution, vesting clarity." },
  { key: "team", label: "Team credibility", hint: "Track record and accountability of the team." },
  { key: "community", label: "Community", hint: "Health and authenticity of the community." },
  { key: "technology", label: "Technology & utility", hint: "Real utility and technical quality." },
  { key: "liquidity", label: "Liquidity & listings", hint: "Depth of liquidity and quality of listings." },
  { key: "communication", label: "Communication", hint: "Responsiveness and honesty of updates." },
];

export const COMPANY_DIMENSIONS: Dimension[] = [
  { key: "security", label: "Security history", hint: "Track record of breaches and how they were handled." },
  { key: "withdrawals", label: "Withdrawal reliability", hint: "Can you reliably get your funds out?" },
  { key: "fees", label: "Fee transparency", hint: "Are fees clear and fair?" },
  { key: "support", label: "Customer support", hint: "Responsiveness and quality of support." },
  { key: "ux", label: "User experience", hint: "Ease and quality of the product." },
  { key: "assets", label: "Asset selection", hint: "Breadth and quality of supported assets." },
  { key: "kyc", label: "KYC / onboarding", hint: "Friction of sign-up and verification." },
  { key: "regulatory", label: "Regulatory standing", hint: "Licensing and compliance posture." },
];

export type EntityType = "token" | "company";

export function dimensionsFor(type: EntityType): Dimension[] {
  return type === "token" ? TOKEN_DIMENSIONS : COMPANY_DIMENSIONS;
}

const KEY_SET: Record<EntityType, Set<string>> = {
  token: new Set(TOKEN_DIMENSIONS.map((d) => d.key)),
  company: new Set(COMPANY_DIMENSIONS.map((d) => d.key)),
};

export function isValidDimension(type: EntityType, key: string): boolean {
  return KEY_SET[type].has(key);
}
